"use strict";

document.addEventListener("DOMContentLoaded", function () {
  //Document Ready
  document.querySelectorAll('.tabs').forEach((tabContainer) => {
    // The class for the container div
    const tabContainerIndex = [].indexOf.call(document.querySelectorAll('.tabs'), tabContainer);
    const wrapTabs = tabContainer.querySelector('.tab-con');

    const tabsContainerWidth = tabContainer.querySelector('.tab-con').offsetWidth;
    const tabsWidth = tabContainer.querySelector('ul.tab-list').offsetWidth;
    const scrollWidth = tabsWidth - tabsContainerWidth;

    tabContainer.querySelector('ul.tab-list').innerHTML = "";
    tabContainer.querySelector('ul.tab-list').setAttribute('role', 'tablist');

    tabContainer.querySelectorAll('.tab-content').forEach((tab) => {
      const tabHeading = tab.querySelector('.tab-title').innerHTML;
      const tabHeadingID = 'tabs' + tabContainerIndex + 'tab' + [].indexOf.call(tabContainer.querySelectorAll('.tab-content'), tab);

      const tabListHTML = `<li>
                          <a href="#${tabHeadingID}">${tabHeading}</a>
                        </li>`;

      tabContainer.querySelector('ul.tab-list').insertAdjacentHTML('beforeend', tabListHTML);
      tab.setAttribute('id', tabHeadingID);
    });

    tabContainer.querySelectorAll('[role="tablist"] > li').forEach((tabLI) => {
      // The setup
      tabLI.setAttribute('role', 'presentation');
    });

    tabContainer.querySelectorAll('[role="tablist"] a').forEach((tabBTN) => {
      // The setup
      tabBTN.setAttribute('role', 'tab');
      tabBTN.setAttribute('tabindex', '-1');

      // Make each aria-controls correspond id of targeted section (re href)
      tabBTN.setAttribute('aria-controls', tabBTN.getAttribute('href').substring(1));
    });

    // Make the first tab selected by default and allow it focus
    tabContainer.querySelector('[role="tablist"] li:first-child a').setAttribute('aria-selected', 'true');
    tabContainer.querySelector('[role="tablist"] li:first-child a').setAttribute('tabindex', '0');

    // Make each section focusable and give it the tabpanel role
    tabContainer.querySelectorAll('section').forEach((tabPNL) => {
      tabPNL.setAttribute('role', 'tabpanel');
    });

    // Make first child of each panel focusable programmatically
    tabContainer.querySelector('section > *:first-child').setAttribute('tabindex', "0");

    // Make all but the first section hidden (ARIA state and display CSS)
    tabContainer.querySelectorAll('[role="tabpanel"]:not(:first-of-type)').forEach((tabPNL) => {
      tabPNL.setAttribute('aria-hidden', 'true');
    });

    tabContainer.querySelectorAll('[role="tab"]').forEach((tab) => {

      // Handle click on tab to show + focus tabpanel
      tab.on('click', function (e) {
        e.preventDefault();
        const tabID = tab.getAttribute('href').substring(1);

        // remove focusability [sic] and aria-selected
        tabContainer.querySelectorAll('[role="tab"]').forEach((t) => {
          t.setAttribute('tabindex', '-1');
          t.removeAttribute('aria-selected');
        });

        // replace above on clicked tab
        tab.setAttribute('aria-selected', true);
        tab.setAttribute('tabindex', '-1');

        // Hide panels
        tabContainer.querySelectorAll('[role="tabpanel"]').forEach((t) => {
          t.setAttribute('aria-hidden', true);
        });

        // show corresponding panel
        document.querySelector(`section#${tabID}`).removeAttribute('aria-hidden');
      });

      // Change focus between tabs with arrow keys
      tab.on('keydown', function (e) {
        // define current, previous and next (possible) tabs
        const tabCurrent = this;
        const tabParent = tabCurrent.closest('li');
        let tabPrev, tabNext, tabTarget;

        if (tabParent.previousElementSibling !== null) {
          tabPrev = this.closest('li').previousElementSibling.querySelector('[role="tab"]');
        }

        if (tabParent.nextElementSibling !== null) {
          tabNext = this.closest('li').nextElementSibling.querySelector('[role="tab"]')
        }

        // find the direction (prev or next)
        switch (e.keyCode) {
          case 37 && tabPrev !== null:
            tabTarget = tabPrev;
            break;
          case 39 && tabNext !== null:
            tabTarget = tabNext;
            break;
          default:
            tabTarget = false;
            break;
        }

        if (tabTarget.length) {
          tabCurrent.setAttribute('tabindex', '-1');
          tabCurrent.removeAttribute('aria-selected');
          tabTarget.setAttribute('tabindex', '0');
          tabTarget.setAttribute('aria-selected', true);
          tabTarget.focus();
        }

        // Hide panels
        tabContainer.querySelector('[role="tabpanel"]').setAttribute('aria-hidden', 'true');
        // Show panel which corresponds to target
        document.getElementById(document.activeElement.getAttribute('href').substring(1)).removeAttribute('aria-hidden');
      });
    });

    if (tabsWidth > tabsContainerWidth) {
      tabContainer.classList.add('scroll-right');
      wrapTabs.on('scroll', function () {
        if (wrapTabs.scrollLeft >= tabsWidth - tabsContainerWidth) {
          tabContainer.classList.remove('scroll-right');
        } else {
          tabContainer.classList.add('scroll-right');
        }
        if (wrapTabs.scrollLeft > 1) {
          tabContainer.classList.add('scroll-left');
        } else {
          tabContainer.classList.remove('scroll-left');
        }
      });
    }
  });
});